<template>
  <a-layout>
    <Breadcrumb />
    <a-page-header title="角色权限设置">
    </a-page-header>
    <div class="content-container">
      <div class="list-container">
        <div class="role-name">授权角色名称：{{ roleName }}</div>
        <a-row>
          <a-col :span="10">
            <a-card title="权限">
              <a-tree
                  :defaultExpandAll="true"
                  :autoExpandParent="true"
                  v-model="checkedKeys"
                  checkable
                  :tree-data="avaFuncTreeData"
                  :replaceFields="menuTreeFields"
              />
            </a-card>
          </a-col>
          <a-col :span="10" :offset="1">
            <a-card title="已授权功能">
              <a-tree
                  :defaultExpandAll="true"
                  :showLine="true"
                  :tree-data="authorizedFuncData"
                  :replaceFields="menuTreeFields"
              />
              <a-empty v-if="!hasAuthorizedFunc" />
            </a-card>
          </a-col>
        </a-row>
        <a-row class="pt-10">
          <a-col :span="8">
            <a-space size="large">
              <a-button type="primary" @click="onSave">授权</a-button>
              <a-button @click="onCancel">取消</a-button>
            </a-space>
          </a-col>
        </a-row>
      </div>
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import {authoirzeWebFunc, loadWebPrivilegeConfig} from "@/services/PrivilegeService";

export default {
  components: {Breadcrumb},
  data() {
    return {
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      avaFuncTreeData: [],
      menuTreeFields: {
        children: "subMenus",
        title: "menuName",
        key: "menuId",
        value: "menuId"
      },
      authorizedFuncData: [],
      roleId: "",
      roleName: ""
    };
  },
  computed: {
    hasAuthorizedFunc() {
      return (
          this.authorizedFuncData !== undefined &&
          this.authorizedFuncData.length > 0
      );
    }
  },
  created() {
    this.loadWebPrivilegeSettings();
  },
  methods: {
    loadWebPrivilegeSettings() {
      this.roleId = this.$route.params.id;
      if (this.roleId) {
        loadWebPrivilegeConfig(this.roleId).then(response => {
          if (response.data.code === "SUCCESS") {
            this.avaFuncTreeData = response.data.data.avaFuncTreeData;
            this.authorizedFuncData = response.data.data.authorizedFuncTreeData;
            this.checkedKeys = response.data.data.authorizedFuncIds;
            this.roleName = response.data.data.roleName;
          } else {
            this.$message.error(response.data.errorMsg);
          }
        });
      } else {
        this.$message.error("出错了");
      }
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSave() {
      let authParams = {
        funcIdList: this.checkedKeys,
        roleId: this.roleId
      };
      authoirzeWebFunc(authParams).then(response => {
        if (response.data.code === "SUCCESS") {
          this.$message.success("授权成功");
          this.authorizedFuncData = response.data.data;
        } else {
          this.$message.error(response.data.errorMsg);
        }
      });
    },
    onCancel() {
      this.$router.push({ name: "RoleList" });
    }
  }
}
</script>

<style scoped>
.role-name {
  font-weight: bold;
  padding-bottom: 10px;
  padding-top: 10px;
}
</style>